import { render, staticRenderFns } from "./dialog-model-move.component.vue?vue&type=template&id=8301dda8"
import script from "./dialog-model-move.component.vue?vue&type=script&lang=ts"
export * from "./dialog-model-move.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports